module.exports = __webpack_public_path__ + "static/media/trash-empty.712af698.svg";